import { MEMBERSHIP_USER_ACCESS_LEVEL } from 'src/features/membership/types';
import { BadgeOption } from 'src/registry/types/badges';
import { membershipUsersMessages } from 'src/features/MembershipCloudUsers/utils/messages';

export const MEMBERSHIP_USER_ACCESS_LEVEL_BADGES: Record<MEMBERSHIP_USER_ACCESS_LEVEL, BadgeOption> = {
    [MEMBERSHIP_USER_ACCESS_LEVEL.ADMIN]: {
        label: membershipUsersMessages.admin,
        theme: 'sky',
    },
    [MEMBERSHIP_USER_ACCESS_LEVEL.MEMBER]: {
        label: membershipUsersMessages.member,
        theme: 'emerald',
    },
    [MEMBERSHIP_USER_ACCESS_LEVEL.GUEST]: {
        label: membershipUsersMessages.guest,
        theme: 'indigo',
    },
};

export const MEMBERSHIP_USER_ACCESS_LEVEL_TRANSLATIONS: Record<
    MEMBERSHIP_USER_ACCESS_LEVEL,
    { id: string; defaultMessage: string }
> = {
    [MEMBERSHIP_USER_ACCESS_LEVEL.ADMIN]: membershipUsersMessages.admin,
    [MEMBERSHIP_USER_ACCESS_LEVEL.MEMBER]: membershipUsersMessages.member,
    [MEMBERSHIP_USER_ACCESS_LEVEL.GUEST]: membershipUsersMessages.guest,
};
